import { useEffect, useState, type FormEvent } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

type SearchFilterProps = {
  value: string;
  onSubmit: (search: string) => void;
};

function SearchFilter({ value, onSubmit }: SearchFilterProps) {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);

  const submit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSubmit(draft.trim());
  };

  return (
    <Form role="search" className="diagnostics-search" onSubmit={submit}>
      <InputGroup size="sm">
        <Form.Control
          type="search"
          aria-label="Search incidents"
          placeholder="Search account, domain, user ID or incident ID…"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
        />
        <Button type="submit" variant="outline-secondary">
          Search
        </Button>
      </InputGroup>
    </Form>
  );
}

export default SearchFilter;
